module.exports = __webpack_public_path__ + "static/media/women-board.3f9f7743.jpg";